/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import '../vendors/jquery-magnificpopup';
import '../vendors/lity.min';
import '../vendors/organic-tab';
import '../vendors/slick.min';
import owlCarousel from '../vendors/owl.carousel.min';
import ScrollReveal from '../vendors/scrollreveal.min.js';

jQuery(document).on('scroll', function () {
	if (jQuery(document).scrollTop() > 0) {
		jQuery('header, body').addClass('shrink');
	} else {
		jQuery('header, body').removeClass('shrink');
	}
});

jQuery(function () {
	/**
	 * Header Wrapper Height Calculation for Navigation Overlay
	 */

	if (jQuery('.header-wrapper').length > 0) {
		function updateHeaderHeight() {
			jQuery('.header-wrapper').each(function () {
				jQuery(this).css('--dma_header-wrapper-default', jQuery(this).outerHeight() + 'px');
			});
		}
		updateHeaderHeight();
		jQuery(window).resize(updateHeaderHeight);
	}

	/**
	 *  Accessibility for Simple menu & Mega menu (desktop)
	 */
	jQuery('.menu-item-has-children > a').on('focus blur', function (event) {
		jQuery(this).siblings('.sub-menu, .mega-menu').toggleClass('focused', event.type === 'focus');
	});

	jQuery('.sub-menu a, .mega-menu a').on('focus blur', function (event) {
		jQuery(this).closest('.sub-menu, .mega-menu').toggleClass('focused', event.type === 'focus');
	});

	/**
	 * Script for Accessibility of html Tags
	 */
	jQuery('h1, h2, h3, h4, h5, h6,p,li,blockquote,cite,strong,dt,dd,th,td,b,i,u,s,em,small,sup,del,ins,abbr,mark,details,pre,kbd,samp,var,address,code,q,figure,figcaption,caption,.top-bar-text,.top-bar-cross,.copy-right,.post-author-img,.post-author-name,.post-meta-date,.post-date').each(function () {
		jQuery(this).attr({
			tabindex: 0,
		});
	});
	jQuery('.header-nav li, .blog-nav li, .footer-nav li, .legal-nav li').each(function () {
		const link = jQuery(this).find('a, span.menu-link');
		if (link.length > 0) {
			jQuery(this).removeAttr('tabindex');
		} else {
			jQuery(this).attr('tabindex', '0');
		}
	});
	jQuery('form p').each(function () {
		jQuery(this).removeAttr('tabindex');
	});

	jQuery('a,button:not([href])').each(function () {
		jQuery(this).attr({
			tabindex: 0,
		});
	});

	setTimeout(() => {
		jQuery('#daextlwcnf-cookie-notice-button-1').attr('role', 'button');
		jQuery('#daextlwcnf-cookie-notice-button-2').attr('role', 'button');
		jQuery('#daextlwcnf-cookie-settings-button-1').attr('role', 'button');
		jQuery('#daextlwcnf-cookie-settings-button-2').attr('role', 'button');
	}, 500);

	autosize();
	function autosize() {
		const text = jQuery('textarea');

		text.each(function () {
			jQuery(this).attr('rows', 5);
			resize(jQuery(this));
		});

		text.on('input', function () {
			resize(jQuery(this));
		});

		function resize($text) {
			$text.css('min-height', 'auto');
			$text.css('min-height', $text[0].scrollHeight + 'px');
		}
	}


});

/*** Scroll Reveal Function ***/

(function scrollReveal() {
	if (typeof ScrollReveal === 'undefined') {
		console.warn('ScrollReveal is not loaded. Heading draw effect is disabled.');
		return;
	}

	const sr = ScrollReveal();
	window.sr = sr;

	/**
	 * Watch helper for class-based enter/exit behavior without transform animation.
	 */
	sr.watch = function (target, onEnter, onExit = function () { }, reset = false) {
		if (typeof onEnter !== 'function' || typeof onExit !== 'function') {
			throw new Error('watch() received invalid callback arguments.');
		}

		this.reveal(target, {
			delay: 0,
			distance: '0px',
			duration: 1,
			scale: 1,
			opacity: 1,
			rotate: { x: 0, y: 0, z: 0 },
			reset: reset,
			beforeReset: onExit,
			beforeReveal: onEnter,
		});
	};

	sr.watch(
		'h1 span, h2 span',
		function onEnter(el) {
			el.classList.add('draw-image');
		},
		function onExit(el) {
			el.classList.remove('draw-image');
		}
	);
})();

/**
 * Team image shuffle animation:
 * Randomly rotates image sources across existing <img> tags.
 * Each cycle: scale/fade out -> swap src/srcset -> scale/fade in.
 */
(function teamImageShuffle() {
	const teamImages = Array.from(document.querySelectorAll('.team-images .team-image img'));
	if (teamImages.length < 2) return;

	const imageSources = teamImages.map((img) => ({
		src: img.getAttribute('src'),
		srcset: img.getAttribute('srcset') || '',
	}));

	let isAnimating = false;

	function shuffleArray(items) {
		const arr = items.slice();
		for (let i = arr.length - 1; i > 0; i -= 1) {
			const j = Math.floor(Math.random() * (i + 1));
			[arr[i], arr[j]] = [arr[j], arr[i]];
		}
		return arr;
	}

	function runShuffle() {
		if (isAnimating) return;
		isAnimating = true;

		const nextOrder = shuffleArray(imageSources);

		if (typeof gsap !== 'undefined') {
			gsap.to(teamImages, {
				scale: 0.75,
				opacity: 0,
				duration: 0.35,
				stagger: 0.03,
				ease: 'power2.out',
				onComplete: () => {
					teamImages.forEach((img, index) => {
						img.setAttribute('src', nextOrder[index].src);
						if (nextOrder[index].srcset) {
							img.setAttribute('srcset', nextOrder[index].srcset);
						} else {
							img.removeAttribute('srcset');
						}
					});

					gsap.fromTo(
						teamImages,
						{ scale: 0.75, opacity: 0 },
						{
							scale: 1,
							opacity: 1,
							duration: 0.45,
							stagger: 0.03,
							ease: 'power2.out',
							onComplete: () => {
								isAnimating = false;
							},
						}
					);
				},
			});
			return;
		}

		teamImages.forEach((img) => {
			img.style.transition = 'transform 0.35s ease, opacity 0.35s ease';
			img.style.transform = 'scale(0.75)';
			img.style.opacity = '0';
		});

		setTimeout(() => {
			teamImages.forEach((img, index) => {
				img.setAttribute('src', nextOrder[index].src);
				if (nextOrder[index].srcset) {
					img.setAttribute('srcset', nextOrder[index].srcset);
				} else {
					img.removeAttribute('srcset');
				}
				img.style.transition = 'transform 0.45s ease, opacity 0.45s ease';
				img.style.transform = 'scale(1)';
				img.style.opacity = '1';
			});

			setTimeout(() => {
				isAnimating = false;
			}, 460);
		}, 360);
	}

	setInterval(runShuffle, 2800);
})();


/**
 * Hexagon grid for .hero-home
 */
(function heroHexGrid() {
	const hexGrid = document.getElementById('hexagonGrid');
	if (!hexGrid) return;

	const container = hexGrid.parentNode;

	function buildHexGrid() {
		const w = container.offsetWidth;
		const h = container.offsetHeight;
		const rowH = 72;
		const colW = 92;
		const rows = Math.ceil(h / rowH) + 1;
		const cols = Math.ceil(w / colW) + 2;

		hexGrid.innerHTML = '';

		for (let i = 0; i < rows; i++) {
			const row = document.createElement('div');
			row.className = 'hex-row';
			for (let j = 0; j < cols; j++) {
				const hex = document.createElement('div');
				hex.className = 'hexagon';
				row.appendChild(hex);
			}
			hexGrid.appendChild(row);
		}
	}
	buildHexGrid();

	window.addEventListener('resize', function () {
		buildHexGrid();
	});
})();



document.querySelectorAll("input[type=file]").forEach(input => {
	input.addEventListener("change", function () {
		const files = this.files;
		const container = this.closest(".upload-container");
		const text = container.querySelector(".upload-text");

		let fileNames = [];

		for (let i = 0; i < files.length; i++) {
			fileNames.push(files[i].name);
		}

		if (fileNames.length > 0) {
			text.textContent = fileNames.join(", ");
		} else {
			text.textContent = ""; // empty if no file
		}
	});
});


jQuery(document).ready(function ($) {
	$('.projects-slider').owlCarousel({
		loop: false,
		margin: 20,
		stagePadding: 10,
		nav: true,
		dots: true,
		autoplay: false,
		animateOut: 'fadeOut',
		animateIn: 'fadeIn',
		smartSpeed: 1000,
		autoplayTimeout: 3000,
		responsive: {
			0: {
				dots: false,
				items: 1
			},
			600: {
				items: 2
			},
			1000: {
				items: 2
			}
		}
	});
});

/**
 * Project card cursor-following tooltip (GLIDE-style)
 * Smooth lerp motion on mousemove, scale in/out on enter/leave.
 */
(function projectTooltipFollow() {
	const cards = document.querySelectorAll('.project-img-over a');
	if (!cards.length) return;

	cards.forEach(function (card) {
		const tooltip = card.querySelector('.tooltip');
		if (!tooltip) return;

		let target = { x: 0, y: 0 };
		let current = { x: 0, y: 0 };
		let rafId = null;
		let isHovering = false;

		function lerp(start, end, factor) {
			return start + (end - start) * factor;
		}

		function animate() {
			current.x = lerp(current.x, target.x, 0.15);
			current.y = lerp(current.y, target.y, 0.15);

			tooltip.style.left = current.x + 'px';
			tooltip.style.top = current.y + 'px';

			if (isHovering) {
				rafId = requestAnimationFrame(animate);
			}
		}

		card.addEventListener('mouseenter', function (e) {
			var rect = card.getBoundingClientRect();
			target.x = e.clientX - rect.left;
			target.y = e.clientY - rect.top;
			current.x = target.x;
			current.y = target.y;

			tooltip.style.left = current.x + 'px';
			tooltip.style.top = current.y + 'px';

			isHovering = true;
			rafId = requestAnimationFrame(animate);
		});

		card.addEventListener('mousemove', function (e) {
			var rect = card.getBoundingClientRect();
			target.x = e.clientX - rect.left;
			target.y = e.clientY - rect.top;
		});

		card.addEventListener('mouseleave', function () {
			isHovering = false;
			if (rafId) {
				cancelAnimationFrame(rafId);
				rafId = null;
			}
		});
	});
})();


(function () {
	var processBlock = document.querySelector('.work-process-block');
	if (!processBlock) return;

	gsap.registerPlugin(ScrollTrigger);

	var items = gsap.utils.toArray('.work-process-block .work-process-item');
	if (!items.length) return;

	var scrollPerItem = 260;
	var stagger = 0.55;

	items.forEach(function (item, i) {
		gsap.set(item, {
			opacity: 0,
			y: -90,
			scale: 0.97,
			position: 'relative',
			zIndex: items.length - i
		});
	});

	var tl = gsap.timeline({
		scrollTrigger: {
			trigger: processBlock,
			start: 'top 80%',
			end: '+=' + items.length * scrollPerItem,
			scrub: 0.65,
			invalidateOnRefresh: true
		}
	});

	items.forEach(function (item, i) {
		tl.to(
			item,
			{
				y: 0,
				opacity: 1,
				scale: 1,
				duration: 0.7,
				ease: 'power2.out'
			},
			i * stagger
		);
	});
})();

/**
 * Team member slide-in panel (Glide-style)
 */
jQuery(function ($) {
	var $overlay = $('.team-member-overlay');
	var $panels = $('.team-member-panel');

	if (!$panels.length) {
		return;
	}

	function closeTeamPanel() {
		$panels.removeClass('is-open').attr('aria-hidden', 'true');
		$overlay.removeClass('is-visible').attr('aria-hidden', 'true');
		$('body').removeClass('team-popup-open');
		$('html, body').removeClass('no-overflow');
	}

	function openTeamPanel($panel, $trigger) {
		var cardBg = $trigger.find('.team-member-image').css('background-color');

		closeTeamPanel();
		$panel.find('.team-member-panel__image').css('background-color', cardBg);
		$panel.addClass('is-open').attr('aria-hidden', 'false');
		$overlay.addClass('is-visible').attr('aria-hidden', 'false');
		$('body').addClass('team-popup-open');
		$('html, body').addClass('no-overflow');
		$panel.find('.team-member-panel__close').trigger('focus');
	}

	$('[data-team-panel]').on('click', function (event) {
		var targetSelector = $(this).attr('data-team-panel');
		var $panel;

		if ($(event.target).closest('.social-icons a').length) {
			return;
		}

		if (!targetSelector || targetSelector.charAt(0) !== '#') {
			return;
		}

		event.preventDefault();
		$panel = $(targetSelector);

		if ($panel.length) {
			openTeamPanel($panel, $(this));
		}
	});

	$('[data-team-panel]').on('keydown', function (event) {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			$(this).trigger('click');
		}
	});

	$('.team-member-panel__close').on('click', function () {
		closeTeamPanel();
	});

	$overlay.on('click', function () {
		closeTeamPanel();
	});

	$(document).on('mouseup', function (event) {
		var $openPanel = $panels.filter('.is-open');

		if (
			$openPanel.length &&
			!$(event.target).closest('.team-member-panel').length
		) {
			closeTeamPanel();
		}
	});

	$(document).on('keydown', function (event) {
		if (event.key === 'Escape') {
			closeTeamPanel();
		}
	});
});




document.addEventListener('DOMContentLoaded', function () {

	if (window.innerWidth <= 747) {

		const navCtn = document.querySelector('.blog-nav .nav-ctn');
		const navList = document.querySelector('.blog-nav ul');
		const navLinks = document.querySelectorAll('.blog-nav ul li a');

		// Active text get
		let activeText = document.querySelector('.blog-nav ul li a.active')?.textContent || 'Categories';

		// Button create
		const button = document.createElement('button');
		button.classList.add('accordion-btn');
		button.innerHTML = `${activeText} <span>+</span>`;

		// Insert button before ul
		navCtn.insertBefore(button, navList);

		// Toggle accordion
		button.addEventListener('click', function () {
			navList.classList.toggle('active');
			button.classList.toggle('active');
		});

		// Click on category
		navLinks.forEach(link => {

			link.addEventListener('click', function () {

				// remove old active
				navLinks.forEach(item => item.classList.remove('active'));

				// add active
				this.classList.add('active');

				// button text update
				button.innerHTML = `${this.textContent} <span>+</span>`;

				// close accordion
				navList.classList.remove('active');
				button.classList.remove('active');
			});

		});

	}

});

import './hero-portfolio';